import { useFormikContext } from 'formik';
import { isObject, isEmpty } from 'lodash';
import { useEffect, useState } from 'react';

const getFirstErrorId = (errorsObject, keys = []) => {
  if (!errorsObject || isEmpty(errorsObject)) {
    return '';
  }

  const firstErrorKey = Object.keys(errorsObject)[0];

  if (isObject(errorsObject[firstErrorKey])) {
    return getFirstErrorId(errorsObject[firstErrorKey], [
      ...keys,
      firstErrorKey,
    ]);
  }

  const finalArray = [...keys, firstErrorKey];

  if (finalArray.length < 2) {
    return finalArray[0];
  }

  // All formik inputs name/id look like that: event[address][city]
  // We need to recreate this from object keys array ['event', 'address', 'city']
  return `${finalArray[0]}[${finalArray.slice(1).join('][')}]`;
};

const ErrorFocus = () => {
  const formik = useFormikContext();
  const [submitCount, setSubmitCount] = useState(formik.submitCount);

  useEffect(() => {
    if (!formik.isValid && formik.submitCount > submitCount) {
      let firstErrorId = getFirstErrorId(formik.errors);

      // Get global input name for Location inputs (remove [lat] ending)
      if (firstErrorId.endsWith('[lat]')) {
        firstErrorId = firstErrorId.slice(0, firstErrorId.length - 5);
      }

      const errorElement = document.getElementById(firstErrorId);

      // The node is not the input hitself, find an input inside
      if (errorElement && errorElement?.nodeName !== 'INPUT') {
        const errorElements = errorElement.getElementsByTagName('INPUT');

        if (errorElements?.length > 0) {
          errorElements[0]?.focus();
        }

        return;
      }

      if (errorElement) {
        errorElement.focus();
      }
      setSubmitCount(formik.submitCount);
    }
  }, [formik.submitCount, formik.isValid, formik.errors]);

  return null;
};

export default ErrorFocus;
